export class IstanzeProcedimentoDTO {
    id: string
    nome: string
}